import React, { useState } from 'react';
import { Bell, BellOff, X, CheckCircle, AlertTriangle, UserX, FileText, Clock, ArrowLeft, Truck, Store, Bike, Users } from 'lucide-react';

const ALL = {
  user: {
    label: 'Users',
    Icon: Users,
    bg: '#f3e8ff', 
    color: '#6d28d9',
    items: [
      { id: 'u1', unread: true, type: 'New', title: 'New user registered', msg: 'Priya Sharma ne account create kiya.', time: '15 min pehle', Icon: CheckCircle, ibg: '#dcfce7', ic: '#166534' },
      { id: 'u2', unread: false, type: 'Report', title: 'User reported', msg: 'User reported issue with payment.', time: '1 ghante pehle', Icon: AlertTriangle, ibg: '#fef9c3', ic: '#854d0e' },
      { id: 'u3', unread: true, type: 'Verified', title: 'User verified', msg: 'Rohit Kumar ka verification complete.', time: '3 ghante pehle', Icon: CheckCircle, ibg: '#dcfce7', ic: '#166534' },
      { id: 'u4', unread: false, type: 'Update', title: 'Profile updated', msg: 'Sneha Patel ne profile update kiya.', time: '5 ghante pehle', Icon: UserX, ibg: '#fee2e2', ic: '#991b1b' },
    ]
  },
  vendor: {
    label: 'Vendors',
    Icon: Truck,
    bg: '#fef9c3', 
    color: '#854d0e',
    items: [
      { id: 'v1', unread: true, type: 'Commission', title: 'Commission rate changed', msg: 'Pizza Palace ka commission 8% se 12% update hua.', time: '20 min pehle', Icon: AlertTriangle, ibg: '#fef9c3', ic: '#854d0e' },
      { id: 'v2', unread: false, type: 'Report', title: 'Monthly report ready', msg: 'June 2026 vendor performance report available hai.', time: 'Kal', Icon: FileText, ibg: '#E6F1FB', ic: '#185FA5' },
      { id: 'v3', unread: true, type: 'Payment', title: 'Payment pending', msg: 'Vendor payment for May is pending.', time: '3 din pehle', Icon: AlertTriangle, ibg: '#fef9c3', ic: '#854d0e' },
      { id: 'v4', unread: false, type: 'Approved', title: 'Vendor approved', msg: 'Fresh Mart vendor registration approved.', time: '6 ghante pehle', Icon: CheckCircle, ibg: '#dcfce7', ic: '#166534' },
    ]
  },
  rider: {
    label: 'Riders',
    Icon: Bike,
    bg: '#dcfce7', 
    color: '#166534',
    items: [
      { id: 'rd1', unread: true, type: 'Onboarded', title: 'New rider onboarded', msg: 'Rahul Sharma ne verification complete kar li.', time: '10 min pehle', Icon: CheckCircle, ibg: '#dcfce7', ic: '#166534' },
      { id: 'rd2', unread: false, type: 'Inactive', title: 'Rider inactive', msg: 'Amit Kumar 3 din se offline hai.', time: '2 ghante pehle', Icon: AlertTriangle, ibg: '#fef9c3', ic: '#854d0e' },
      { id: 'rd3', unread: true, type: 'Completed', title: 'Delivery completed', msg: 'Rider completed 50 deliveries this week.', time: '1 din pehle', Icon: CheckCircle, ibg: '#dcfce7', ic: '#166534' },
      { id: 'rd4', unread: true, type: 'Earnings', title: 'Rider earnings updated', msg: 'Weekly earnings report is now available.', time: '3 ghante pehle', Icon: FileText, ibg: '#E6F1FB', ic: '#185FA5' },
    ]
  }
};

function NotifCard({ n, onDismiss }) {
  const Icon = n.Icon;
  
  return (
    <div style={{
      display: 'flex', 
      alignItems: 'flex-start', 
      gap: '10px',
      background: '#fff', 
      border: n.unread ? '1px solid #B5D4F4' : '1px solid #e5e7eb',
      borderLeft: n.unread ? '3px solid #378ADD' : '1px solid #e5e7eb',
      borderRadius: '8px', 
      padding: '10px 12px', 
      position: 'relative', 
      marginBottom: '6px',
      transition: 'all 0.2s ease',
      width: '100%',
      boxSizing: 'border-box',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.boxShadow = 'none';
    }}
    >
      {n.unread && (
        <span style={{ position: 'absolute', top: '8px', right: '8px', width: '6px', height: '6px', borderRadius: '50%', background: '#378ADD' }} />
      )}
      <div style={{ 
        width: '32px', 
        height: '32px', 
        borderRadius: '8px', 
        background: n.ibg, 
        color: n.ic, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        flexShrink: 0 
      }}>
        <Icon size={14} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '2px' }}>
          <span style={{ fontSize: '11px', fontWeight: '600', color: '#111827' }}>{n.title}</span>
          <span style={{
            fontSize: '8px',
            color: n.unread ? '#378ADD' : '#6b7280',
            background: n.unread ? '#eff6ff' : '#f3f4f6',
            padding: '1px 6px',
            borderRadius: '4px',
            fontWeight: 500,
          }}>
            {n.type}
          </span>
        </div>
        <p style={{ fontSize: '10px', color: '#6b7280', margin: '0 0 4px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {n.msg}
        </p>
        <span style={{ fontSize: '9px', color: '#9ca3af', display: 'flex', alignItems: 'center', gap: '3px' }}>
          <Clock size={9} /> {n.time}
        </span>
      </div>
      <button 
        onClick={() => onDismiss(n.id)} 
        style={{ 
          background: 'none', 
          border: 'none', 
          cursor: 'pointer', 
          color: '#9ca3af', 
          padding: '2px',
          flexShrink: 0,
          borderRadius: '4px',
          transition: 'all 0.2s',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#f3f4f6';
          e.currentTarget.style.color = '#ef4444';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.color = '#9ca3af';
        }}
      >
        <X size={12} />
      </button>
    </div>
  );
}

export default function ShowNotification() {
  const [data, setData] = useState(ALL);
  const [view, setView] = useState('main');

  const totalUnread = Object.values(data).flatMap(c => c.items).filter(n => n.unread).length;

  const dismiss = (cat, id) => {
    setData(prev => ({
      ...prev,
      [cat]: { ...prev[cat], items: prev[cat].items.filter(n => n.id !== id) }
    }));
  };

  const markAllRead = () => {
    setData(prev => {
      const next = {};
      Object.keys(prev).forEach(k => {
        next[k] = { ...prev[k], items: prev[k].items.map(n => ({ ...n, unread: false })) };
      });
      return next;
    });
  };

  // Get all items for preview
  const allItems = [
    ...data.user.items.map(n => ({ ...n, cat: 'user' })),
    ...data.vendor.items.map(n => ({ ...n, cat: 'vendor' })),
    ...data.rider.items.map(n => ({ ...n, cat: 'rider' })),
  ];
  const previewItems = allItems.slice(0, 3);

  // Group by category
  const userItems = data.user.items.map(n => ({ ...n, cat: 'user' }));
  const vendorItems = data.vendor.items.map(n => ({ ...n, cat: 'vendor' }));
  const riderItems = data.rider.items.map(n => ({ ...n, cat: 'rider' }));

  // Check if all sections are empty
  const allEmpty = userItems.length === 0 && vendorItems.length === 0 && riderItems.length === 0;

  return (
    <div style={{ 
      padding: '20px', 
      maxWidth: '1200px', 
      margin: '0 auto', 
      fontFamily: 'sans-serif',
      background: '#f8fafc',
      minHeight: '100vh',
      borderRadius: '12px',
    }}>

      {/* Header */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        padding: '14px 20px',
        background: '#fff',
        borderRadius: '12px',
        borderBottom: '1px solid #e5e7eb', 
        marginBottom: '20px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {view === 'all' && (
            <button 
              onClick={() => setView('main')} 
              style={{ 
                background: 'none', 
                border: 'none', 
                cursor: 'pointer', 
                color: '#378ADD', 
                display: 'flex', 
                alignItems: 'center', 
                gap: '4px', 
                fontSize: '13px', 
                padding: '4px 10px',
                borderRadius: '6px',
                transition: 'all 0.2s',
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = '#eff6ff'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
            >
              <ArrowLeft size={15} /> Back
            </button>
          )}
          {view === 'main' && <Bell size={18} color="#378ADD" />}
          <span style={{ fontSize: '15px', fontWeight: '600', color: '#111827' }}>
            {view === 'main' ? 'Notifications' : 'All Notifications'}
          </span>
          {totalUnread > 0 && (
            <span style={{ 
              background: '#378ADD', 
              color: '#fff', 
              fontSize: '10px', 
              fontWeight: '500', 
              padding: '2px 8px', 
              borderRadius: '10px' 
            }}>
              {totalUnread}
            </span>
          )}
        </div>
        <button 
          onClick={markAllRead} 
          style={{ 
            fontSize: '11px', 
            color: '#378ADD', 
            background: 'none', 
            border: 'none', 
            cursor: 'pointer',
            padding: '4px 10px',
            borderRadius: '6px',
            transition: 'all 0.2s',
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = '#eff6ff'}
          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
        >
          Mark all as read
        </button>
      </div>

      {/* Main View - 3 Column Layout */}
      {view === 'main' && (
        <>
          {allEmpty ? (
            <div style={{ 
              textAlign: 'center', 
              padding: '3rem 0', 
              color: '#9ca3af',
              background: '#fff',
              borderRadius: '12px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            }}>
              <BellOff size={40} style={{ display: 'block', margin: '0 auto 10px' }} />
              <p style={{ fontSize: '14px' }}>Koi notification nahi</p>
            </div>
          ) : (
            // 3 Column Layout - Users | Vendors | Riders
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                background: '#fff',
                padding: '16px',
                borderRadius: '12px',
                boxSizing: 'border-box',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                minHeight: '300px',
                gap: '16px',
              }}
            >
              {/* Users Column */}
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  boxSizing: 'border-box',
                }}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  paddingBottom: '8px',
                  borderBottom: '2px solid #f3e8ff',
                }}>
                  <div style={{
                    width: '26px',
                    height: '26px',
                    borderRadius: '6px',
                    background: '#f3e8ff',
                    color: '#6d28d9',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <Users size={14} />
                  </div>
                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>Users</span>
                  <span style={{ 
                    fontSize: '10px', 
                    color: '#6b7280', 
                    marginLeft: 'auto',
                    background: '#f3f4f6',
                    padding: '1px 6px',
                    borderRadius: '8px',
                  }}>
                    {userItems.length}
                  </span>
                </div>
                {userItems.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '20px 0', color: '#9ca3af', fontSize: '11px' }}>
                    No notifications
                  </div>
                ) : (
                  userItems.map(n => (
                    <NotifCard 
                      key={n.id} 
                      n={n} 
                      onDismiss={(id) => dismiss('user', id)} 
                    />
                  ))
                )}
              </div>

              {/* Vendors Column */}
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  boxSizing: 'border-box',
                  borderLeft: '1px solid #e5e7eb',
                  borderRight: '1px solid #e5e7eb',
                  padding: '0 16px',
                }}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  paddingBottom: '8px',
                  borderBottom: '2px solid #fef9c3',
                }}>
                  <div style={{
                    width: '26px',
                    height: '26px',
                    borderRadius: '6px',
                    background: '#fef9c3',
                    color: '#854d0e',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <Truck size={14} />
                  </div>
                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>Vendors</span>
                  <span style={{ 
                    fontSize: '10px', 
                    color: '#6b7280', 
                    marginLeft: 'auto',
                    background: '#f3f4f6',
                    padding: '1px 6px',
                    borderRadius: '8px',
                  }}>
                    {vendorItems.length}
                  </span>
                </div>
                {vendorItems.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '20px 0', color: '#9ca3af', fontSize: '11px' }}>
                    No notifications
                  </div>
                ) : (
                  vendorItems.map(n => (
                    <NotifCard 
                      key={n.id} 
                      n={n} 
                      onDismiss={(id) => dismiss('vendor', id)} 
                    />
                  ))
                )}
              </div>

              {/* Riders Column */}
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  boxSizing: 'border-box',
                }}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  paddingBottom: '8px',
                  borderBottom: '2px solid #dcfce7',
                }}>
                  <div style={{
                    width: '26px',
                    height: '26px',
                    borderRadius: '6px',
                    background: '#dcfce7',
                    color: '#166534',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <Bike size={14} />
                  </div>
                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>Riders</span>
                  <span style={{ 
                    fontSize: '10px', 
                    color: '#6b7280', 
                    marginLeft: 'auto',
                    background: '#f3f4f6',
                    padding: '1px 6px',
                    borderRadius: '8px',
                  }}>
                    {riderItems.length}
                  </span>
                </div>
                {riderItems.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '20px 0', color: '#9ca3af', fontSize: '11px' }}>
                    No notifications
                  </div>
                ) : (
                  riderItems.map(n => (
                    <NotifCard 
                      key={n.id} 
                      n={n} 
                      onDismiss={(id) => dismiss('rider', id)} 
                    />
                  ))
                )}
              </div>
            </div>
          )}
          
          <button 
            onClick={() => setView('all')} 
            style={{ 
              display: 'block', 
              width: '100%', 
              marginTop: '12px', 
              padding: '10px', 
              fontSize: '13px', 
              color: '#378ADD', 
              border: '1px solid #B5D4F4', 
              borderRadius: '8px', 
              background: '#fff',
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#eff6ff';
              e.currentTarget.style.borderColor = '#378ADD';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#fff';
              e.currentTarget.style.borderColor = '#B5D4F4';
            }}
          >
            See all notifications
          </button>
        </>
      )}

      {/* All View - 3 Column Layout (Same as Main View) */}
      {view === 'all' && (
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            background: '#fff',
            padding: '16px',
            borderRadius: '12px',
            boxSizing: 'border-box',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            minHeight: '300px',
            gap: '16px',
          }}
        >
          {/* Users Column */}
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              boxSizing: 'border-box',
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              paddingBottom: '8px',
              borderBottom: '2px solid #f3e8ff',
            }}>
              <div style={{
                width: '26px',
                height: '26px',
                borderRadius: '6px',
                background: '#f3e8ff',
                color: '#6d28d9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <Users size={14} />
              </div>
              <span style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>Users</span>
              <span style={{ 
                fontSize: '10px', 
                color: '#6b7280', 
                marginLeft: 'auto',
                background: '#f3f4f6',
                padding: '1px 6px',
                borderRadius: '8px',
              }}>
                {data.user.items.length}
              </span>
            </div>
            {data.user.items.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '20px 0', color: '#9ca3af', fontSize: '11px' }}>
                <CheckCircle size={22} style={{ display: 'block', margin: '0 auto 6px' }} /> Sab clear hai
              </div>
            ) : (
              data.user.items.map(n => <NotifCard key={n.id} n={n} onDismiss={(id) => dismiss('user', id)} />)
            )}
          </div>

          {/* Vendors Column */}
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              boxSizing: 'border-box',
              borderLeft: '1px solid #e5e7eb',
              borderRight: '1px solid #e5e7eb',
              padding: '0 16px',
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              paddingBottom: '8px',
              borderBottom: '2px solid #fef9c3',
            }}>
              <div style={{
                width: '26px',
                height: '26px',
                borderRadius: '6px',
                background: '#fef9c3',
                color: '#854d0e',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <Truck size={14} />
              </div>
              <span style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>Vendors</span>
              <span style={{ 
                fontSize: '10px', 
                color: '#6b7280', 
                marginLeft: 'auto',
                background: '#f3f4f6',
                padding: '1px 6px',
                borderRadius: '8px',
              }}>
                {data.vendor.items.length}
              </span>
            </div>
            {data.vendor.items.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '20px 0', color: '#9ca3af', fontSize: '11px' }}>
                <CheckCircle size={22} style={{ display: 'block', margin: '0 auto 6px' }} /> Sab clear hai
              </div>
            ) : (
              data.vendor.items.map(n => <NotifCard key={n.id} n={n} onDismiss={(id) => dismiss('vendor', id)} />)
            )}
          </div>

          {/* Riders Column */}
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              boxSizing: 'border-box',
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              paddingBottom: '8px',
              borderBottom: '2px solid #dcfce7',
            }}>
              <div style={{
                width: '26px',
                height: '26px',
                borderRadius: '6px',
                background: '#dcfce7',
                color: '#166534',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <Bike size={14} />
              </div>
              <span style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>Riders</span>
              <span style={{ 
                fontSize: '10px', 
                color: '#6b7280', 
                marginLeft: 'auto',
                background: '#f3f4f6',
                padding: '1px 6px',
                borderRadius: '8px',
              }}>
                {data.rider.items.length}
              </span>
            </div>
            {data.rider.items.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '20px 0', color: '#9ca3af', fontSize: '11px' }}>
                <CheckCircle size={22} style={{ display: 'block', margin: '0 auto 6px' }} /> Sab clear hai
              </div>
            ) : (
              data.rider.items.map(n => <NotifCard key={n.id} n={n} onDismiss={(id) => dismiss('rider', id)} />)
            )}
          </div>
        </div>
      )}
    </div>
  );
}